import { useFormik } from "formik";
import React from "react";
import { NavLink } from "react-router-dom";
import InputField from "shared/InputField";
import InputSelect from "shared/InputSelect";
import { categories } from "utilities/data";
import { ngoSignUpValidationSchema } from "validation/ngo/signupSchema";

const Details = ({ next, setBody }) => {
  const formik = useFormik({
    initialValues: {
      name: "",
      year_founded: "",
      category: "",
      yearly_report: "",
      yearly_projects: "",
      website: "",
      address: "",
    },
    validationSchema: ngoSignUpValidationSchema,
    onSubmit: (values) => {
      const body = {
        name: values.name,
        year_founded: values.year_founded,
        category: values.category,
        yearly_projects: values.yearly_projects,
        yearly_report: values.yearly_report,
        website: values.website,
        address: values.address,
      };
      setBody(body);
      next();
    },
  });

  const yearlyProjectsOptions = [
    {
      title: "true",
      value: true,
    },
    {
      title: "false",
      value: false,
    },
  ];

  const yearlyReportsOptions = [
    {
      title: "true",
      value: true,
    },
    {
      title: "false",
      value: false,
    },
  ];

  return (
    <div>
      <div className="mb-2 w-full">
        <p className="text-[20px] font-bold mb-2">NGO Contact Form</p>
        <div className="flex items-center mb-8 justify-start gap-2">
          <p className="text-[#7A7A7A]">Already have an account? </p>
          <NavLink to="/auth/ngo/login">
            <p className="underline text-[#213874] font-medium hover:font-semibold">
              Login
            </p>
          </NavLink>
        </div>
      </div>
      <form onSubmit={formik.handleSubmit} className="w-full mb-6">
        <div className="flex flex-col gap-4 w-full">
          <div className="w-full flex flex-col gap-2">
            <InputField
              className="border border-[#E6E6E6] rounded-md"
              type="text"
              name="name"
              label="Name of NGO"
              placeholder="Peace charity"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
            />
            {formik.touched.name && formik.errors.name ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.name}
              </p>
            ) : null}
          </div>
          <div className="relative flex flex-col gap-2">
            <InputField
              className="border border-[#E6E6E6] rounded-md"
              type="text"
              label="Year Founded"
              name="year_founded"
              placeholder="1999"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.year_founded}
            />
            {formik.touched.year_founded && formik.errors.year_founded ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.year_founded}
              </p>
            ) : null}
          </div>
          <div className="w-full">
            <label className="text-[14px] mb-8 font-normal">Category</label>
            <InputSelect
              options={categories}
              name="category"
              onChange={formik.handleChange}
              optionsHolder="Select category"
              value={formik.values.category}
              divClass="!h-[55px]"
            />
            {formik.touched.category && formik.errors.category ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.category}
              </p>
            ) : null}
          </div>
          <div className="w-full">
            <label className="text-[14px] font-normal">
              Does your NGO run projects yearly?
            </label>
            <InputSelect
              options={yearlyProjectsOptions}
              name="yearly_projects"
              onChange={formik.handleChange}
              optionsHolder="Select option"
              value={formik.values.yearly_projects}
              divClass="!h-[55px]"
            />
            {formik.touched.yearly_projects && formik.errors.yearly_projects ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.yearly_projects}
              </p>
            ) : null}
          </div>
          <div className="w-full">
            <label className="text-[14px] font-normal">
              Does your NGO publish yearly impact reports?
            </label>
            <InputSelect
              options={yearlyReportsOptions}
              name="yearly_report"
              onChange={formik.handleChange}
              optionsHolder="Select option"
              value={formik.values.yearly_report}
              divClass="!h-[55px]"
            />
            {formik.touched.yearly_report && formik.errors.yearly_report ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.yearly_report}
              </p>
            ) : null}
          </div>
          <div className="flex flex-col gap-2">
            <InputField
              className="border border-[#E6E6E6] rounded-md"
              type="text"
              name="website"
              label="Website"
              placeholder="www.peacecharity.co"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.website}
            />
            {formik.touched.website && formik.errors.website ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.website}
              </p>
            ) : null}
          </div>
          <div className="flex flex-col gap-2">
            <InputField
              className="border border-[#E6E6E6] rounded-md"
              type="text"
              name="address"
              label="NGO address"
              placeholder="Enter address"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.address}
            />
            {formik.touched.address && formik.errors.address ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.address}
              </p>
            ) : null}
          </div>
          <div>
            <button
              type="submit"
              className="w-full h-[50px] rounded-lg bg-[#213874] hover:bg-[#182d62] px-4 py-2 flex items-center justify-center"
            >
              <p className="text-white font-semibold">Next</p>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Details;
